// extracted by mini-css-extract-plugin
export var container = "_u8-0";
export var table = "_u8-2";
export var tableWrapper = "_u8-1";